import styled from "@xstyled/styled-components";

import { pxToRem } from "@otta/design-tokens";

export const FooterContent = styled.div<{ align?: "center" }>`
  margin: 0 auto;
  max-width: ${pxToRem(490)};
  text-align: ${({ align = "inherit" }) => align};
`;
